const getLoadingSpinner = function (color) {
  var spinner = document.createElement('div')
  var bounce1 = document.createElement('div')
  var bounce2 = document.createElement('div')
  var bounce3 = document.createElement('div')
  spinner.className = 'spinner'
  bounce1.className = 'bounce1'
  bounce1.style.backgroundColor = color
  bounce2.className = 'bounce2'
  bounce2.style.backgroundColor = color
  bounce3.className = 'bounce3'
  bounce3.style.backgroundColor = color
  spinner.appendChild(bounce1)
  spinner.appendChild(bounce2)
  spinner.appendChild(bounce3)
  return spinner
}

/**
 *
 * @param {import("../App").Loading=} loading
 * @returns
 */
const getEmbedHtml = function (loading) {
  var container = document.createElement('div')
  var iframeContainer = document.createElement('div')
  iframeContainer.className = 'dot-embed-iframe-container'
  if (loading) {
    var loadingEl = document.createElement('div')
    loadingEl.className = 'dot-embed-loading'
    loadingEl.appendChild(getLoadingSpinner(loading.color))
    container.appendChild(loadingEl)
  }
  container.appendChild(iframeContainer)
  return container
}

const getUrlParameter = (name = '') => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(window.location.search)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

/**
 * @param {import("../App").LegacyLoading|import("../App").Loading} loading
 * @param {string=} loadingColor
 * @return {import("../App").Loading}
 */
function convertLegacyLoadingIntoLoading(loading, loadingColor) {
  const DEFAULT_LOADING = { color: loadingColor || '#595959' }

  if (!loading) return DEFAULT_LOADING
  if (loading === 'off') return undefined
  if (typeof loading === 'string') return DEFAULT_LOADING
  if (typeof loading === 'boolean') return loading ? DEFAULT_LOADING : undefined
  if (typeof loading === 'object') return loading
  return undefined
}

/**
 * Runs queued onLoad calls
 * @param {Array<[CallableFunction]>} queue
 */
const loadQueue = (queue = []) => {
  for (let i = 0; i < queue.length; i++) {
    try {
      queue[i][0](window.dotEmbed)
    } catch (e) {
      console.warn(e)
    }
  }
}

/**
 * Convert the old 'load' queue into the new 'onLoad' queue.
 * @param {*} args
 * @returns {[CallableFunction]}
 */
function convertLegacyLoadToOnload(args) {
  return [({ load }) => load.apply(null, args)]
}

export {
  getEmbedHtml,
  getUrlParameter,
  convertLegacyLoadingIntoLoading,
  loadQueue,
  convertLegacyLoadToOnload,
}
